module.exports = __webpack_public_path__ + "static/media/cash_white.a92ce2b2.svg";